import errorAnimationData from './animations/error.lottie.js';
import foodLoopAnimationData from './animations/food-loop.lottie.js';
import loadingAnimationData from './animations/loading.lottie.js';
import successAnimationData from './animations/success.lottie.js';

var LOADING_ANIMATION_OPTIONS = {
  loop: true,
  autoplay: true,
  animationData: loadingAnimationData
};
var SUCCESS_ANIMATION_OPTIONS = {
  loop: false,
  autoplay: true,
  animationData: successAnimationData
};
var ERROR_ANIMATION_OPTIONS = {
  loop: false,
  autoplay: true,
  animationData: errorAnimationData
};
var FOOD_LOOP_ANIMATION_OPTIONS = {
  loop: true,
  autoplay: true,
  animationData: foodLoopAnimationData
};

export { ERROR_ANIMATION_OPTIONS, FOOD_LOOP_ANIMATION_OPTIONS, LOADING_ANIMATION_OPTIONS, SUCCESS_ANIMATION_OPTIONS };
